import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { element } from 'protractor';
import { EventsService } from '../../core/services/events.service';
import { EventBasicInfo } from '../../core/models/event-basic-info';
import { Router, ActivatedRoute } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { FormControl } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { } from 'googlemaps';
import { Ng2Datetime } from 'ng2-datetime-picker';
import { DatePipe } from '@angular/common';
import { ExtraService } from '../../core/services/extra.service';
import { NodeService } from '../../core/services/nodeservice';
import { constants } from 'os';
import { ProfileService } from '../../core/services/profile.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-info',
  templateUrl: './info.html',
  styleUrls: ['./info.css'],
  providers: [EventsService, DatePipe, ExtraService, NodeService, ProfileService]
})
export class InfoComponent implements OnInit {
  minDate = new Date();

  selectedStartTime: string = null;
  selectedEndTime: string = null;

  buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
  pageTitle: string = 'Event Basic Info';
  idClass = "form-control";
  nameClass = "form-control";
  startTimeClass = "dateIcon";
  endTimeClass = "dateIcon";
  locationClass = "form-control";
  descClass = "form-control";

  eventIdList = new Array<string>();

  lat: number;
  long: number;
  validUniqueId: boolean;
  startDate: Date;
  endDate: Date;
  eventBasicInfo = new EventBasicInfo();
  isError = false;
  autoGeneratedKey: string;
  errorMessage: string[];
  public zoom: number;
  message: string = null;
  eventId: string = null;
  eventEditors: any[];
  showAdminControls: boolean = false;

  UNIQUE_ID_REGEXP = /^[A-Z0-9_-]*$/i;

  LABEL_PUBLIC_EVENT_DESCRIPTION = Constants.LABEL_PUBLIC_EVENT_DESCRIPTION;
  LABEL_SHORT_VENUE_DESCRIPTION = Constants.LABEL_SHORT_VENUE_DESCRIPTION;

  @ViewChild("search")
  public searchElementRef: ElementRef;

  constructor(
    private extraService: ExtraService, 
    public datepipe: DatePipe, 
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private route: ActivatedRoute, 
    private router: Router, 
    private eventsService: EventsService,
    private profileService: ProfileService,
    private nodeService: NodeService,
  ) {
  }

  ngOnInit() {
    this.zoom = 4;
    this.getEventIdList();
    this.eventBasicInfo.isEventPublic = false;
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {

      });

      // To get latlong from location
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          console.log(JSON.stringify(place));
          this.eventBasicInfo.locationAddress = this.searchElementRef.nativeElement.value;
          this.eventBasicInfo.latitude = place.geometry.location.lat();
          this.eventBasicInfo.longitude = place.geometry.location.lng();
          this.lat = this.eventBasicInfo.latitude;
          this.long = this.eventBasicInfo.longitude;
          this.zoom = 12;
        });
      });
    });

    this.route.queryParams.subscribe(params => {
      let id = params['eventId'];
      if (id) {
        this.eventId = id
        this.setEventData(id);
        this.eventsService.getEventEditors(id).then(data => this.eventEditors = data);
        this.extraService.setCurrentEventId(id);
        this.eventsService.isEventEditor(id).then(isEditor => {
          if(isEditor) this.showAdminControls = false
          else this.showAdminControls = true
        })
      }
    });
  }

  getEventIdList() {
    this.eventsService.getEventList().snapshotChanges().subscribe(list => {
      this.eventIdList = new Array();
      list.forEach(element => {
        let event = element.payload.toJSON();
        this.eventIdList.push(event + '');
      });
    });
  }

  setEventData(id) {
    this.eventsService.getEventBasicInfo(id).subscribe(event => {
      if (event) {
        this.extraService.setCurrentEventId(id);
        this.eventBasicInfo = event;
        this.searchElementRef.nativeElement.value = event.locationAddress;
        this.startDate = new Date(this.stringToFormatedDateString(event.startTime));
        this.selectedStartTime = this.startDate.getHours() + ':' + this.startDate.getMinutes();
        let date = new Date();
        this.endDate = new Date(this.stringToFormatedDateString(event.endTime));
        this.selectedEndTime = this.endDate.getHours() + ':' + this.endDate.getMinutes();
        this.lat = this.eventBasicInfo.latitude;
        this.long = this.eventBasicInfo.longitude;

        this.zoom = 12;
      } else {
        this.router.navigate([Constants.WELCOME_URL]);
      }
    });
  }

  submit() {
    this.validate();
    if (!this.isError) {
      console.log(this.startDate);
      this.eventBasicInfo.startTime = this.datepipe.transform(this.startDate, Constants.DATE_TIME_FORMAT);
      console.log(this.eventBasicInfo.startTime);
      this.eventBasicInfo.endTime = this.datepipe.transform(this.endDate, Constants.DATE_TIME_FORMAT);
      if (!this.eventBasicInfo.eventId) {
        this.add();
      } else {
        this.update();
      }
    }
  }

  validateUniqueId() {
    this.isError = false;
    this.errorMessage = new Array();
    this.setDefaultClasses();
    if (this.eventBasicInfo.aliasId == null || this.eventBasicInfo.aliasId.trim().length < 1) {
      this.isError = true;
      this.errorMessage.push("UniqueId cannot be empty");
      this.idClass = "fieldWithErrors form-control";
    } else if (!this.UNIQUE_ID_REGEXP.test(this.eventBasicInfo.aliasId)) {
      this.isError = true;
      this.errorMessage.push("UniqueId can have uppercase(A-Z), 0-9 and underscore(_) only");
      this.idClass = "fieldWithErrors form-control";
    } else {
      this.eventBasicInfo.aliasId = this.eventBasicInfo.aliasId.toUpperCase();
      var uniqueId = this.eventBasicInfo.aliasId;
      this.eventsService.checkUniqueIdExist().then((snapshot) => {
        this.validUniqueId = !snapshot.child(uniqueId).exists(); // true
        if (!this.validUniqueId && !this.eventBasicInfo.eventId) {
          this.isError = true;
          if (this.errorMessage.indexOf("UniqueId already used") == -1) {
            this.errorMessage.push("UniqueId already used");
          }
          this.idClass = "fieldWithErrors form-control";
        }
      });
    }
  }

  validate() {
    this.validateUniqueId();
    this.message = null;
    if (this.eventBasicInfo.name == null || this.eventBasicInfo.name.trim().length < 1) {
      this.isError = true;
      this.errorMessage.push("Name cannot be empty");
      this.nameClass = "fieldWithErrors form-control";
    }
    if (this.startDate == null) {
      this.isError = true;
      this.errorMessage.push("Start Time is not valid");
      this.startTimeClass = "fieldWithErrors dateIcon";
    }
    if (this.endDate == null) {
      this.isError = true;
      this.errorMessage.push("End Time is not valid");
      this.endTimeClass = "fieldWithErrors dateIcon";
    }
    if (this.endDate != null && this.endDate != null && (this.dateDiff(this.endDate, this.startDate)) > 15) {
      console.log((this.endDate.getDate() - this.startDate.getDate()));
      this.isError = true;
      this.errorMessage.push("End Date cannot be more than 15days from the Start Date");
      this.startTimeClass = "fieldWithErrors dateIcon";
      this.endTimeClass = "fieldWithErrors dateIcon";
    }
    if (this.endDate != null && this.endDate != null && (this.dateDiff(this.endDate, this.startDate)) < 0) {
      console.log((this.endDate.getDate() - this.startDate.getDate()));
      this.isError = true;
      this.errorMessage.push("End Date cannot be less than the Start Date");
      this.startTimeClass = "fieldWithErrors dateIcon";
      this.endTimeClass = "fieldWithErrors dateIcon";
    }
    if (this.eventBasicInfo.locationAddress == null || this.eventBasicInfo.locationAddress.trim().length < 1 || this.eventBasicInfo.latitude == null || this.eventBasicInfo.longitude == null) {
      this.isError = true;
      this.errorMessage.push("Enter a valid location");
      this.locationClass = "fieldWithErrors form-control";
    }
  }

  dateDiff(date1, date2) {
    var datediff = date1.getTime() - date2.getTime();
    return (datediff / (24 * 60 * 60 * 1000));
  }

  setDefaultClasses() {
    this.idClass = "form-control";
    this.nameClass = "form-control";
    this.startTimeClass = "dateIcon";
    this.endTimeClass = "dateIcon";
    this.locationClass = "form-control";
    this.descClass = "form-control";
  }

  add() {
    let basicDetail = this.eventBasicInfo;
    console.log(this.eventIdList);
    if (this.validUniqueId) {
      var eventId = this.eventsService.createNewEvent(basicDetail.aliasId);
      basicDetail.aliasId = basicDetail.aliasId;
      basicDetail.eventId = eventId;
      this.eventsService.addBasicInfo(basicDetail, eventId);
      this.eventIdList.push(eventId);
      this.eventsService.addEventToEventList(eventId, this.eventIdList);
      this.message = "Event Added Successfully";
      setTimeout(function () {
        this.message = null;
      }.bind(this), 2000);
      this.router.navigate([Constants.INFO_URL], { queryParams: { eventId: eventId } });
    } else {
      this.isError = true;
      this.errorMessage = new Array();
      this.errorMessage.push("Unique Id is Not Available");
    }
  }

  selectStartDate(event) {
    console.log(event);
    if (this.selectedStartTime) {
      if (this.selectedStartTime && this.startDate) {
        let timeData: string[] = this.selectedStartTime.split(':');
        let h: number = +timeData[0];
        let m: number = +timeData[1];
        this.startDate.setHours(h, m, 0);
        this.startDate = new Date(this.startDate);
      } else if (this.startDate) {
        this.startDate.setHours(0, 0, 0);
        this.startDate = new Date(this.startDate);
      }
    } else {
      this.startDate.setHours(9, 0, 0);
      this.selectedStartTime = '9:0';
      this.startDate = new Date(this.startDate);
    }
  }

  selectEndDate() {
    console.log(this.endDate);
    console.log(event);
    if (this.selectedEndTime) {
      if (this.selectedEndTime && this.endDate) {
        let timeData: string[] = this.selectedEndTime.split(':');
        let h: number = +timeData[0];
        let m: number = +timeData[1];
        this.endDate.setHours(h, m, 0);
        this.endDate = new Date(this.endDate);
      } else if (this.endDate) {
        this.endDate.setHours(0, 0, 0);
        this.endDate = new Date(this.endDate);
      }
    } else {
      this.endDate.setHours(9, 0, 0);
      this.selectedEndTime = '9:0';
      this.endDate = new Date(this.endDate);
    }
  }

  changeStartTime(event: string) {
    if (event && this.startDate) {
      this.selectedStartTime = event;
      let timeData: string[] = event.split(':');
      let h: number = +timeData[0];
      let m: number = +timeData[1];
      this.startDate.setHours(h, m, 0);
      this.startDate = new Date(this.startDate);
    } else if (this.startDate) {
      this.startDate.setHours(9, 0, 0);
      this.selectedStartTime = '9:0';
      this.startDate = new Date(this.startDate);
    }
  }

  changeEndTime(event: string) {
    if (event && this.endDate) {
      this.selectedEndTime = event;
      let timeData: string[] = event.split(':');
      let h: number = +timeData[0];
      let m: number = +timeData[1];
      this.endDate.setHours(h, m, 0);
      this.endDate = new Date(this.endDate);
    } else if (this.endDate) {
      this.endDate.setHours(9, 0, 0);
      this.selectedEndTime = '9:0';
      this.endDate = new Date(this.endDate);
    }
  }

  update() {
    console.log(this.eventBasicInfo);
    console.log("update");
    this.eventsService.updateBasicInfo(this.eventBasicInfo);
    this.message = "Event Update Successfully";
    setTimeout(function () {
      this.message = null;
    }.bind(this), 2000);
  }

  onChoseLocation(event) {
    this.eventBasicInfo.latitude = event.coords.lat;
    this.eventBasicInfo.longitude = event.coords.lng;

    // getting address from lat long
    var latlng = { lat: event.coords.lat, lng: event.coords.lng };
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': latlng }, (results, status) => {
      if (status) {
        if (results[0]) {
          console.log(JSON.stringify(results));
          this.searchElementRef.nativeElement.value = results[0].formatted_address;
          this.eventBasicInfo.locationAddress = results[0].formatted_address;
        } else {
          this.searchElementRef.nativeElement.value = 'No results found';
        }
      } else {
        console.log('Geocoder failed due to: ' + status);
      }
    });

  }

  //To format string for date
  stringToFormatedDateString(str: string): string {
    let formatedDateString = str;
    console.log(str);
    if (str.length == 17) {
      formatedDateString = str.substring(4, 8) + '-' + str.substring(2, 4) + '-' + str.substring(0, 2) + 'T' + str.substring(9);
    }
    return formatedDateString;
  }

  async addEditor(el: HTMLInputElement){
    const email = el.value
    const firebaseUid = await this.nodeService.getFirebaseUid(email)
    console.log("Email:", email, firebaseUid)
    this.eventsService.addEventEditor(this.eventId, firebaseUid, email)
    el.value = ""
  }

  // TODO::@ashutoshpw
  // Remove Editors functions
  // async removeEditor(){
  //   const dbPath = `${Constants.EVENT_EDITOR_LIST_URL}`;
    
  // }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/info/info.ts